import { z } from 'zod';

export function useValidateFilesBeforeUpload() {
  const { t } = useI18n();
  const filesForUpload = ref<FileList>();
  const errorMessage = ref<string | undefined>();

  function onFilesForUploadSelected(fileList: FileList) {
    const fileValidation = multiFileValidator.safeParse(fileList);
    if (fileValidation.success) {
      errorMessage.value = undefined;
      filesForUpload.value = fileList;
    } else {
      const issue = fileValidation.error.issues[0];
      if (issue.code === z.ZodIssueCode.custom) {
        errorMessage.value = t(issue.message, { ...issue.params });
      }
    }
  }

  return {
    onFilesForUploadSelected,
    filesForUpload,
    errorMessage,
  };
}
